define('rebrush/components/product/view/media',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/components/Registry',
	'modernizr',
	'elevatezoom',
	'cartware-slider',
	'magnific-popup'
], function(
	$,
	_,
	Component,
	BEM,
	Registry
) {
	var cache = {
		galleries: {}
	};

	return Component.create({
		block:				null,
		wrap:				null,
		thumbs:				null,
		badge:				null,
		galleryListItems:	null,
		galleryImages:		null,
		galleryElement:		null,
		spConfig:			null,

		$init: function() {
			this.initializeComponent();
			this.initializeWrap();
			this.initializeBadge();

			Registry().retrieve('product.view.configurable.spConfig', _.bind(function(spConfig) {
				this.spConfig = spConfig;
				this.initializeSimpleObservation();
			}, this));

			cache.galleries.__initial = this.block;
		},

		initializeComponent: function() {
			this.block = BEM.block('product-media');

			this.galleryListItems = this.block.getElements('gallery-list-item');
			this.galleryImages = this.block.getElements('gallery-image');

			this.initializeThumbnails();
			this.createZoom(this.galleryListItems.filter(':modifier(visible)').find(this.galleryImages));
		},

		initializeWrap: function() {
			this.block.wrap($('<div data-product-media-wrap />'));
			this.wrap = this.block.closest('[data-product-media-wrap]');
		},

		initializeBadge: function() {
			this.badge = this.block.getElements('badge-image-container');
		},

		initializeThumbnails: function() {
			this.thumbs = this.block.getElements('more-views-thumb-link');

			this.thumbs.each(function(i) {
				$(this).data('image-index', i);
			});

			this.thumbs.on('click', _.bind(this._onThumbnailClick, this));
			this.thumbs.first().click();
		},

		initializeSimpleObservation: function() {
			var currentSimple = _.get(this.spConfig, '__currentGallerySimple');
			var _onChangeGallerySimple = _.bind(function(e, simple) {
				this.changeSimple(simple);
			}, this);

			$(document).on('product/changeGallerySimple', _onChangeGallerySimple);

			if (currentSimple) {
				_onChangeGallerySimple(null, currentSimple);
			}
		},

		changeSimple: function(simple) {
			var block;

			if (!(simple.id in cache.galleries)) {
				cache.galleries[simple.id] = $(simple.mediaGallery);
			}

			block = cache.galleries[simple.id];

			$('.zoomContainer').remove();

			// this.block.wrap(wrap);

			//this.block.replaceWith(block);
			// block.replaceAll(this.block);

			this.wrap.empty().append(block);
			this.initializeComponent();

			// Append initial badge if simple doesn't carry one on its own
			if (this.badge.length && !this.block.getElements('badge-image-container').length) {
				this.block.getElements('gallery').append(this.badge);
			}

			var sliderBlock = this.block.find('.cartware-slider');

			if (sliderBlock.length) {
				sliderBlock.cartwareSlider()
					.data('cartware_slider/instance')
					.on('ready', function() {

					});
			}
		},

		_onThumbnailClick: function(e) {
			var thumb = $(e.currentTarget),
				itemWrap = thumb.data('media-gallery-item-wrap'),
				listItem = thumb.data('media-gallery-image'),
				galleryImage;

			if (!itemWrap) {
				itemWrap = thumb.closest('.cartware-slider-item-wrap');
				thumb.data('media-gallery-item-wrap', itemWrap);
			}

			if (!listItem) {
				listItem = this.galleryListItems.filter('[data-item="' + thumb.data('image-index') + '"]');
				thumb.data('media-gallery-image', listItem);
			}

			galleryImage = listItem.find(this.galleryImages);

			e.preventDefault();

			this.destroyZoom();

			this.galleryListItems.filter(':modifier(visible)')
				.bemRemoveModifier('visible');

			itemWrap.closest('.cartware-slider').find('.cartware-slider-item-wrap--active').removeClass('cartware-slider-item-wrap--active');
			itemWrap.addClass('cartware-slider-item-wrap--active');

			listItem.bemAddModifier('visible');

			if (!thumb.data('prevent-zoom')) {
				this.createZoom(galleryImage);
			}

			$(document).trigger('product/changeGalleryPicture');
		},

		createZoom: function(image) {
			var self = this;

			if (!Modernizr.touch) {
				image.elevateZoom({
					zoomType: 'inner',
					responsive: true
				});
			}

			image.on('click', function(e) {
				var items = [],
					index = 0,
					imageSrc = image.attr('src');

				if ($.magnificPopup.instance.isOpen) {
					return;
				}

				self.galleryImages.each(function(i) {
					var src = $(this).attr('src');

					if (i > 0 || self.galleryImages.length === 1) { // skip default image
						items.push({
							src: src
						});

						if (i > 0 && index === 0 && src === imageSrc) {
							index = i - 1;
						}
					}
				});

				$.magnificPopup.open({
					items: items,
					type: 'image',
					gallery: {
						enabled: true
					}
				}, index);
			});
		},

		destroyZoom: function() {
			$('.zoomContainer').remove();
			this.galleryListItems.filter(':modifier(visible)')
				.find('.' + BEM.buildElementClassname('product-media', 'gallery-image'))
				.removeData('elevateZoom');
		},

		destructor: function() {
			this.spConfig = null;
		}
	});
});
